<template>
  <div>
    <v-container class="promoterDashboard">
      <v-row>
        <v-col lg="6" md="6" sm="12">
          <v-card>
            <v-card-title class="cardt">
              <v-row>
                <v-col lg="8" > 
                  <span>{{ $escapeHtml.decode(eventCurrent.title) }}</span>
                </v-col>
                <v-col lg="4" > 
                    <v-menu
                      v-model="menu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field 
                        outlined dense 
                        :label="$tc('promoterDashboard.eventDate')" 
                        v-model="dateCurrent"
                        append-icon="far fa-calendar-alt"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        class="dateCard"
                        disabled
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="dateCurrent"
                      @input="menu = false"
                      :header-date-format="$datePicker.formatDateHeader"
                      :title-date-format="$datePicker.formatTitleDate"
                      :weekday-format="$datePicker.formatWeekday"
                      :month-format="$datePicker.formatMonth"
                    ></v-date-picker>
                    </v-menu>
                </v-col>
              </v-row>             
            </v-card-title>
            <v-card-text>
              <p>{{ $tc("promoterDashboard.subtitle_current") }}</p>
              <v-row>
                <v-col md="6">
                  <v-btn class="btn" 
                        @click="changePageCurrent('eventDetails')"
                  >{{ $tc("promoterDashboard.btn_event_details") }}</v-btn>
                </v-col>
                <v-col md="6">
                  <v-btn class="btn" 
                  @click="changePageCurrent('EventClasses')"
                  >{{ $tc("promoterDashboard.btn_classes") }}</v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col md="6">
                  <v-btn class="btn" 
                  @click="changePageCurrent('EventBrands')"
                  >{{ $tc("promoterDashboard.btn_brands") }}</v-btn>
                </v-col>
                <v-col md="6">
                  <v-btn class="btn" 
                  @click="changePageCurrent('Registration')"
                  >{{ $tc("promoterDashboard.btn_registration") }}</v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col md="6">
                  <v-btn class="btn" 
                  @click="changePageCurrent('StartGrids')"
                  >{{ $tc("promoterDashboard.btn_start_grid") }}</v-btn>
                </v-col>
                <v-col md="6">
                  <v-btn class="btn" 
                  @click="changePageCurrent('WaitList')"
                  >{{ $tc("promoterDashboard.btn_wait_list") }}</v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col md="12">
                  <v-btn class="btn" 
                  @click="changePageCurrent('Teams')"
                  >{{ $tc("promoterDashboard.btn_teams") }}</v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col lg="6" md="6" sm="12">
          <v-card>
            <v-card-title class="cardt">
              <v-row>
                <v-col lg="8" > 
                  <span>{{ $escapeHtml.decode(eventPast.title) }}</span>
                </v-col>
                <v-col lg="4" > 
                  <v-menu
                    v-model="menu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field 
                        outlined dense 
                        :label="$tc('promoterDashboard.eventDate')" 
                        v-model="datePast"
                        append-icon="far fa-calendar-alt"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        class="dateCard"
                        disabled
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="datePast"
                      @input="menu2 = false"
                      :header-date-format="$datePicker.formatDateHeader"
                      :title-date-format="$datePicker.formatTitleDate"
                      :weekday-format="$datePicker.formatWeekday"
                      :month-format="$datePicker.formatMonth"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-card-title>
            <v-card-text>
              <p>{{ $tc("promoterDashboard.subtitle_past") }}</p>
              <v-row>
                <v-col md="6">
                  <v-btn class="btn" 
                  @click="changePagePast('eventDetails')"
                  >{{ $tc("promoterDashboard.btn_event_details") }}</v-btn>
                </v-col>
                <v-col md="6">
                  <v-btn class="btn" 
                  @click="changePagePast('EventClasses')"
                  >{{ $tc("promoterDashboard.btn_classes") }}</v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col md="6">
                  <v-btn class="btn" 
                  @click="changePagePast('EventBrands')"
                  >{{ $tc("promoterDashboard.btn_brands") }}</v-btn>
                </v-col>
                <v-col md="6">
                  <v-btn class="btn" 
                  @click="changePagePast('Registration')"
                  >{{ $tc("promoterDashboard.btn_registration") }}</v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col md="6">
                  <v-btn class="btn" 
                  @click="changePagePast('StartGrids')"
                  >{{ $tc("promoterDashboard.btn_start_grid") }}</v-btn>
                </v-col>
                <v-col md="6">
                  <v-btn class="btn" 
                  @click="changePagePast('WaitList')"
                  >{{ $tc("promoterDashboard.btn_wait_list") }}</v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col md="12">
                  <v-btn class="btn" 
                  @click="changePagePast('Teams')"
                  >{{ $tc("promoterDashboard.btn_teams") }}</v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { apiCalls } from "@/mixins/apiCalls.js";

export default {
  mixins: [apiCalls],
  name:"PromoterDashboard",
  data(){
    return{
      eventPast: {
        id: 0, //ID Test
        title: ''
      },
      eventCurrent: {
        id: 0, //ID Test
        title: ''
      },
      buttonColor:'#fff',
      menu2: false,
      menu: false,
      dateCurrent: null,
      datePast: null
    }
  },
  created(){
    //const { primary } = this.$vuetify.theme.themes.light;
    //this.buttonColor = primary.darken2;//process.env.VUE_APP_HEADER_COLOR;
  },
  methods:{
    changePageCurrent(name = ""){
      if(name !== "") {
        this.$router.push({
          name, params: { id: this.eventCurrent.id }
        });
      }
    },
    changePagePast(name = ""){
      if(name !== "") {
        this.$router.push({
          name, params: { id: this.eventPast.id }
        });
      }
    },
    async loadDashboard() {
      const date = new Date();
      const month = date.getMonth() < 9 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
      const day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
      const dateString = `${date.getFullYear()}-${month}-${day}`;
      const data = { paramDate: dateString };
      const response = await this.api(
          "post",
          "/api/v1/promoter/upcomingEvents",
          data
      ); 
      const { success, message } = response;
      if( success ) { 
        const { lastEvent, upcomingEvent } = message;
        this.eventPast.id = lastEvent ? lastEvent.id : '';
        this.eventPast.title = lastEvent ? lastEvent.eventName : '';
        this.datePast = lastEvent ? lastEvent.eventDate : '';
        this.eventCurrent.id = upcomingEvent ? upcomingEvent.id : '';
        this.eventCurrent.title = upcomingEvent ? upcomingEvent.eventName : '';
        this.dateCurrent = upcomingEvent ? upcomingEvent.eventDate : '';
      }
    }
  },
  mounted(){
    this.loadDashboard();
  }
}
</script>
<style scoped>
.cardt{background: var(--v-accent-base) !important; color: var(--v-primary-darken2) !important; position: relative;}
.promoterDashboard .v-card__text { color: var(--v-primary-base) !important; }
.btn{
  background-color: var(--v-primary-darken2) !important;
  border-color: var(--v-primary-base) !important;
  width: 200px;
  color:var(--v-lighten-base) !important;
  text-transform: none;
  font-weight: bold;
}
.btn span {color: var(--v-lighten-base) !important;}

</style>